<materials-calculator-cms [pageModel]="model"></materials-calculator-cms>
